import React, { FC, useEffect, useState, useRef } from 'react'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import s from './Services.module.scss'
import CardServices from '../../../components/CardServices/CardServices'
import { useAppSelector } from '../../../store/hooks'
import { animationLifting } from '../../../utils'



const Services: FC = () => {
    const { info } = useAppSelector(state => state.info)
    const controls = useAnimation()
    const { ref, inView } = useInView({ threshold: 0.1 })
    const [hasAnimated, setHasAnimated] = useState(false)
    const [centeredCardId, setCenteredCardId] = useState<number | null>(null)
    const cardRefsRef = useRef<Map<number, React.RefObject<HTMLDivElement>>>(new Map())

    useEffect(() => {
        if (inView && !hasAnimated) {
            controls.start('visible')
            setHasAnimated(true)
        }
    }, [controls, inView, hasAnimated])

    // Функция для определения карточки, ближайшей к центру экрана
    const findClosestToCenter = () => {
        const viewportHeight = window.innerHeight
        const centerY = viewportHeight / 2
        let closestId: number | null = null
        let minDistance = Infinity

        cardRefsRef.current.forEach((ref, id) => {
            if (!ref.current) return
            
            const rect = ref.current.getBoundingClientRect()
            const cardCenterY = rect.top + rect.height / 2
            const distanceFromCenter = Math.abs(cardCenterY - centerY)
            
            // Карточка должна быть видимой и ближе к центру
            if (rect.top < viewportHeight && rect.bottom > 0 && distanceFromCenter < minDistance) {
                minDistance = distanceFromCenter
                closestId = id
            }
        })

        return closestId
    }

    // Проверка центральной карточки при скролле (только на мобильных)
    useEffect(() => {
        const isMobile = window.innerWidth <= 991
        if (!isMobile) return

        const handleScroll = () => {
            const closestId = findClosestToCenter()
            
            // Просто обновляем центральную карточку - старые закроются автоматически
            if (closestId !== null && closestId !== centeredCardId) {
                setCenteredCardId(closestId)
            } else if (closestId === null && centeredCardId !== null) {
                // Если ни одна карточка не в центре, закрываем текущую
                setCenteredCardId(null)
            }
        }

        // Проверяем при скролле с debounce
        let scrollTimeout: NodeJS.Timeout
        const debouncedScroll = () => {
            clearTimeout(scrollTimeout)
            scrollTimeout = setTimeout(handleScroll, 50)
        }

        window.addEventListener('scroll', debouncedScroll, { passive: true })
        handleScroll() // Проверяем сразу

        return () => {
            window.removeEventListener('scroll', debouncedScroll)
            clearTimeout(scrollTimeout)
        }
    }, [centeredCardId])

    return (
        <section className={s.section}>
            <div className={`${s.container} container`}>
                <h2 className={`${s.title} title`}><span></span>МЫ ПРЕДЛАГАЕМ</h2>
                <div
                    className={`${s.wrapper}`}
                >
                    {
                        info?.list_services?.map((el, index) => {
                            // Создаем ref для каждой карточки
                            if (!cardRefsRef.current.has(el.id)) {
                                cardRefsRef.current.set(el.id, React.createRef<HTMLDivElement>())
                            }
                            
                            return (
                                <CardServices
                                    key={el.id}
                                    data={el}
                                    isFirst={index === 0}
                                    isCentered={centeredCardId === el.id}
                                    cardRef={cardRefsRef.current.get(el.id)}
                                />
                            )
                        })
                    }
                </div>
            </div>
            <div className={s.shape_right} />
            <span className='lineGradient bottom-line ' />
        </section>
    )
}

export default Services
